<mat-card class="q2-comment-card">
	<mat-card-content>
		<div *ngIf="comments.length > 0; else noComments">
			<div class="q2-comment-container" (scroll)="scrolled($event)" #scrollframe>
				<div class="q2-comment-item" *ngFor="let item of comments" #item>
					<span class="__header">
						{{ item?.user?.first_name | user }}
						{{ item?.user?.last_name | user }} -
						{{ item?.createdAt | date : 'medium' }}
					</span>
					<p *ngIf="!item.text.includes('Direct notification')" class="__content">
						{{ item.text }}
					</p>
					<p (mouseenter)="showNotification.emit(item?.notification || null)" *ngIf="item.text.includes('Direct notification')" class="__content-alt">
						{{ item.text }}
					</p>
				</div>
			</div>
			<hr style="border: 0.5px solid rgba(0, 0, 0, 0.12); margin: 0px" />
		</div>
		<ng-template #noComments>
			<div class="q2-comment-container">
				<p class="__content" style="margin: 0px">No notes available yet</p>
			</div>
		</ng-template>
		<div fxLayout="row" class="input-section" [formGroup]="form">
			<mat-form-field fxFlex="85" floatLabel="always" class="input-field" appearance="outline" style="padding-bottom: 0px">
				<textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" formControlName="comment" placeholder="Enter new note here"></textarea>
			</mat-form-field>

			<button [disableRipple]="true" fxFlex mat-icon-button color="primary" [disabled]="form.invalid" (click)="addComment()">
				<mat-icon>send</mat-icon>
			</button>
		</div>
	</mat-card-content>
</mat-card>
